import * as z from 'zod';

// Types
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

const OfferFormZod = z.object({
  __component: z.literal('block.form-offer'),
  id: z.number(),
  title: TitleZod,
  paragraph: ParagraphZod,
  waveWrapper: WaveWrapperZod.nullable(),
});

export type OfferFormType = z.infer<typeof OfferFormZod>;

export { OfferFormZod };
